import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../containers/Layout';
import PageTitle from '../components/PageTitle';
import { connect } from 'react-redux';
import { getBracketById, getParticipantById } from '../redux/app';
import Form from '../containers/ParticipantForm';

const Participant = (props) => {
  const { participantId, id } = props.match.params;
  const dictionary = participantId
    ? 'app.tree.participant.edit'
    : 'app.tree.participant.create';
  const participantTitle = props.participant && props.participant.name;
  return (
    <Layout
      title={[
        !id && { messageId: dictionary },
        id && { messageId: props.title, to: `/tree/edit/${id}` },
        participantId && { messageId: participantTitle },
      ]}
    >
      <PageTitle messageId={dictionary} />
      <Form
        treeId={id}
        id={participantId}
        defaultValues={props.participant || {}}
      />
    </Layout>
  );
};

Participant.propTypes = {
  title: PropTypes.string,
  match: PropTypes.object,
  participant: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  ...getBracketById(state, ownProps.match.params.id),
  participant: getParticipantById(
    state,
    ownProps.match.params.id,
    ownProps.match.params.participantId
  ),
});

export default connect(mapStateToProps)(Participant);
